import { Link, useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { ApiError, api } from '../../api/client.js';
import { keys } from '../../api/hooks.js';
import { Chapi } from '../../components/Chapi.js';
import { markMagicLinkSignIn } from '../../lib/passkeys.js';
import { nextRoute } from '../../lib/two-factor.js';
import { AuthLayout } from './AuthLayout.js';

/** The magic link lands here. The token is in the URL fragment so it never reaches server logs. */
export function Verify() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = new URLSearchParams(window.location.hash.slice(1)).get('token');
    history.replaceState(null, '', window.location.pathname);
    if (!token) {
      setError('This link is incomplete. Ask for a new one.');
      return;
    }
    api('verifyMagicLink', { body: { token } })
      .then((state) => {
        markMagicLinkSignIn();
        qc.setQueryData(keys.session, state);
        void navigate({ to: nextRoute(state) });
      })
      .catch((err) => setError(err instanceof ApiError ? err.message : 'That link did not work.'));
  }, [navigate, qc]);

  return (
    <AuthLayout>
      {error ? (
        <>
          <Chapi pose="sorry" size={90} />
          <h1>That link did not work</h1>
          <p>{error}</p>
          <Link className="btn btn-primary" to="/sign-in">Back to sign in</Link>
        </>
      ) : (
        <>
          <Chapi pose="working" size={90} />
          <h1>Signing you in…</h1>
        </>
      )}
    </AuthLayout>
  );
}
